import moment from 'moment';

export const AS_SOON_AS_POSSIBLE_DATE = new Date().toISOString().split('T')[0];
const asSoonAsPossibleMoment = moment.utc(AS_SOON_AS_POSSIBLE_DATE, 'YYYY-MM-DD');
const asSoonAsPossibleString: string = 'z.s.m.';

export const getOvDate = (date: string, asapText: boolean = false) => {
  return ovDate(date, ['YYYY-MM-DD'], 'YYYY-MM-DD', asapText);
};

export const getDutchDateFormat = (date: string) => {
  return ovDate(date, ['YYYY-MM-DD', 'DD/MM/YYYY'], 'DD/MM/YYYY', false);
};

export const getDutchLongDateFormat = (date: string, asapText: boolean = false) => {
  return ovDate(date, ['YYYY-MM-DD hh:mm', 'DD-MM-YYYY hh:mm'], 'DD/MM/YYYY LT', asapText);
};

const ovDate = (date: string, inputFormats: string[], outputFormat: string, asapText: boolean = false) => {
  if (date === null) {
    return null;
  }

  const momentDate = moment.utc(date, inputFormats);

  if (
    asapText
    && momentDate.isSame(asSoonAsPossibleMoment)
  ) {
    return asSoonAsPossibleString;
  } else {
    return momentDate.locale('nl-NL').format(outputFormat);
  }
};
